export type SieveSortDirection = 'asc' | 'desc';

export const sieveSortProperty = 'sorts';
export function toSieveSortType(sortDirection: string): SieveSortDirection | undefined {
	return sortDirection === 'asc' ? 'asc' : sortDirection === 'desc' ? 'desc' : undefined;
}

export const buildSortValue = (sortBy: string, sortDirection: string): string => {
	const sortDir = sortDirection === 'asc' ? '' : '-';
	if (sortBy.indexOf('|') < 0) {
		return `${sortDir}${sortBy}`;
	}

	return sortBy
		.split('|')
		.map(x => `${sortDir}${x}`)
		.join(',');
};

export const buildSort = (sortBy: string, sortDirection: string) => {
	if (!sortBy && !sortDirection) {
		return `${sieveSortProperty}=`;
	}

	const sortValue = buildSortValue(sortBy, sortDirection);
	return `${sieveSortProperty}=${sortBy.indexOf('|') < 0 ? sortValue : encodeURIComponent(sortValue)}`;
};
